/* eslint-disable import/prefer-default-export */
import React, { ReactElement } from 'react';
import { PickerItemHandler } from '../../editor/fields/helpers/editor-fields-helper';
import { ParentRecordState } from '../../record-editor';
import TaskPickerItem from './task-picker-item';

const ALLOW_MULTILPE_SELECTION = true;

export const taskPickerItemHandler = (): PickerItemHandler => ({
  view: (record: Record<string, any>): ReactElement => (<TaskPickerItem task={record} />),
  // @ts-ignore
  selectionHandler: (
    records: Record<string, any>[],
    selectedTaskIDs: any[],
    parentRecordState: ParentRecordState,
  ) => ({
    selectedTaskIDs,
    newParentRecordState: {
      ...parentRecordState,
      allowMultiple: ALLOW_MULTILPE_SELECTION,
    },
  }),
  recordLinkedTitle: 'Linked Task',
  selectorTitle: 'Select from list',
  allowMultiple: ALLOW_MULTILPE_SELECTION,
});
